import React from "react"
import Button from "@material-ui/core/Button/Button"
import DialogContent from "@material-ui/core/DialogContent/DialogContent"
import DialogActions from "@material-ui/core/DialogActions/DialogActions"
import { USER } from "../../library/store/actions/types/authTypes"
import HoldsPicker from "../../components/v2/inputs/pickers/HoldsPicker"
import styled from "@emotion/styled"
import { calendarEventsColors } from "../../library/constants/calendar"
import CheckIcon from "@material-ui/icons/CheckCircle"
import { useBookMeet } from "./bookMeetContext"
import { productContentTypes } from "../../library/constants/productDictionary"
import StaticDataSelect from "../../components/v2/inputs/select/staticDataSelect"

const MeetTypeSwitcher = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  width: 100%;
`

const MeetTypeButton = styled.button`
  position: relative;
  padding: 15px;
  border: 2px solid ${(props) => props.borderColor};
  border-radius: 4px;

  svg {
    position: absolute;
    top: 5px;
    right: 5px;
    color: ${(props) => props.borderColor};
  }
`

const BookMeetStep2 = () => {
  const {
    data,
    setData,
    setStep,
    availableHolds,
    availableTypes,
    onHoldChange,
    onClose,
  } = useBookMeet()

  const toNextStep = () => setStep(3)

  // console.log(availableTypes)

  const canGoNext = data.hold && data.type

  return (
    <>
      <DialogContent className={"pb15"}>
        <div className="f jcc mb50">
          <p className="text-center" style={{ maxWidth: 340 }}>
            Please select by Hold and by appointment length in minutes. A Hold
            is a bracketed open time that can be scheduled with this user and
            will usually be labeled for selection appropriate to the requester.
            not selecting a Hold will use any open time and the user can elect
            to accept or offer a different time.
          </p>
        </div>
        <div className="full-width f jcc">
          <div className="form form--modal">
            <StaticDataSelect
              fieldName={"hold"}
              entityName={"hold"}
              data={availableHolds}
              value={data.hold}
              onChange={onHoldChange}
            />
            <MeetTypeSwitcher>
              {availableTypes.map((v, i) => {
                const isActive = data.type === v
                return (
                  <MeetTypeButton
                    key={v}
                    onClick={() =>
                      setData((prevState) => ({
                        ...prevState,
                        type: v,
                        time: null,
                        date: null,
                      }))
                    }
                    borderColor={calendarEventsColors[i].hex}
                    isActive={isActive}
                  >
                    <p className={"mb5"}>{v}-Minute Meeting</p>
                    <p className={"color-black-54"}>
                      Set for {v} minutes meeting
                    </p>
                    {isActive && <CheckIcon />}
                  </MeetTypeButton>
                )
              })}
            </MeetTypeSwitcher>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button color="primary" onClick={toNextStep} disabled={!canGoNext}>
          Next
        </Button>
      </DialogActions>
    </>
  )
}

export default BookMeetStep2
